import React from 'react';

const Education = () => {
  return (
    <section id="education" className="section">
      <div className="container">
        <h2 className="section-title">Education</h2>
        <div className="education-card">
          <h3 className="education-title">Jain University</h3>
          <div className="education-degree">B.Tech — Information Science & Engineering</div>
          <div className="education-duration">(2023–2027)</div>
        </div>
      </div>
    </section>
  );
};

export default Education;